export default __webpack_public_path__ + "static/media/externalOff.56abc12f.svg";